<template>
    <div>
        <a-form-item 
            validate-status="error"
            label="备注类型"
            :help="help"
            :labelCol="{span: labelSpan}"
            :wrapperCol="{span: wrapperSpan}">
            <a-radio-group :disabled="disabled" v-decorator="['remarkCategoryCode',{rules: [{required:true,message:'请选择备注类型'}]}]" @change="onChange">
                <a-radio v-for="item in remarkList" :key="item.id" :value="item.categoryCode">
                    {{item.categoryName}}
                </a-radio>
            </a-radio-group>
        </a-form-item>
        <a-form-item v-show="false">
            <a-input :disabled="disabled" v-decorator="['remarkCategoryName']"></a-input>
        </a-form-item>
        <a-form-item 
            label="备注"
            :labelCol="{span: labelSpan}"
            :wrapperCol="{span: wrapperSpan}">
            <a-textarea :disabled="disabled" :maxLength="15" v-decorator="['remark',{rules: [{required:true,message:'请输入备注(15字以内)',max:15}]}]" placeholder="请输入" :rows="2" />
            <span class="text-disabled">{{$parent.form.getFieldValue('remark') ? String($parent.form.getFieldValue('remark')).length : 0}}/15</span>
        </a-form-item>
    </div>
</template>
<script>
    /**
     * 备注组件
     * @prop {Boolean} labelSpan 文字宽度
     * @prop {Boolean} wrapperSpan 内容宽度
     * @prop {String} help 备注类型必填提示
     * @prop {String} operateCode 备注类型必填提示
     * @prop {Boolean} disabled 禁用
     */
    export default {
        data() {
            return {
                remarkList: []
            }
        },
        props: {
            labelSpan: {type: Number},
            wrapperSpan: {type: Number},
            help: {type: String},
            operateCode: {type: String},
            disabled: {type: Boolean, default: false},
        },
        methods: {
            getRemarkList() {
                this.$api.totalPlatform.getRemarkCategoryByOperate({
                    params: {
                        operateCode: this.operateCode
                    }
                }).then(res => {
                    this.remarkList = res
                }).catch(err => {

                })
            },
            onChange(e) {
                this.remarkList.forEach(remark => {
                    if(remark.categoryCode === e.target.value) {
                        this.$parent.form.setFieldsValue({'remarkCategoryName': remark.categoryName});
                    }
                })
                
            },
        },
        mounted() {
            this.getRemarkList();
        }
    }
</script>